var account = "계정";
var accountSettings = "계정 설정";
var charging = "충전";
var contactInfo = "연락처 정보";
var dashboard = "대시보드";
var home = "홈";
var myProducts = "내 제품";
var orderHistory = "주문 내역";
var paymentMethod = "결제 방법";
var profileSettings = "운전자 프로필 설정";
var referAndEarn = "추천하고 크레딧 획득";
var signOut = "로그아웃";
var ko_KR = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, ko_KR as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
